/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/


// Load event function ... most custom stuff goes here. Safer for async.
window.addEventListener( 'load', function() {

	/**
	 * Linkclicker
	 * 
	 * A class placed on a wrapping element with a link inside to make the wrapper clickable.
	 */
	var linkclickers = document.querySelectorAll('.linkclicker');

	for ( var i = 0; linkclickers.length > i; i++ ) {
		var linkclicker = linkclickers[i];

		linkclicker.addEventListener('click', function(e) {
			e.preventDefault();
			var link = this.querySelector('a');
			var linkPath = link.getAttribute('href');
			
			if ( link.getAttribute('target', "_blank") ) {
				window.open(linkPath);
			} else {
				window.location.href = linkPath;
			}
		});
	}


	/**
	 * Force external links to open in a new tab.
	 * 2019-07-11 - TA
	 */
	// From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
	function link_is_external(link_element) {
		return (link_element.host !== window.location.host);
	}

	var anchorElements = document.getElementsByTagName('a');
	for (let anchorElement of anchorElements) {

		if ( link_is_external(anchorElement ) && ( anchorElement.href !== 'javascript:void(0);' ) ) {
			anchorElement.setAttribute('target','_blank');
			anchorElement.setAttribute('rel','noopener');

			// Add assistive text to alert of external links
			var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
			var assistiveTextContainer = document.createElement('span');
			assistiveTextContainer.innerHTML = assistiveText;
			anchorElement.appendChild(assistiveTextContainer.firstChild);
		}
	}


	/**
	 * 	Alert Banner Scripts
	 */
	var banner_element = document.querySelector('.banner-statement');
	var button_element = document.querySelector('.banner-statement-toggle-button');
	
	if (button_element) {
		button_element.addEventListener('click', function () {
			banner_element.classList.toggle('open-statement');
		});
	}

	
	/**
	 * Local Storage of Ink Types to pre-populate contact form with user interest
	 */
	var technology 	= '';
	var inkType 	= '';

	// If on an Inks page, but not the /inks/ landing page, set localStorage to page title
	if ( window.location.href.indexOf("/inks/") != -1 && window.location.pathname != '/inks/' ) {
		inkType = document.getElementById('site').getAttribute('data-page-name');
		localStorage.setItem('technology', inkType);
	}

	// If page has contact form, add local storage data about recent ink view
	var has_contact = document.querySelector('#gform_fields_1 .ink-form-field');
	var field = document.querySelector('.ink-form-field input');

	if ( has_contact ) {
		if ( localStorage.getItem('technology') ) {
			technology = localStorage.getItem('technology');
		}

		if ( localStorage.getItem('ink-type') ) {
			inkType = localStorage.getItem('ink-type');
		}

		// Prevents duplicate text when form is on an ink page
		if ( technology != inkType ) {
			field.value = technology + ' ' + inkType;
		} else {
			field.value = inkType;
		}
	}

	var community_toggles = document.querySelectorAll('.community-service__toggle');

	if (community_toggles) {
		for (let toggle of community_toggles) {
			toggle.addEventListener('click', function() {
				this.classList.toggle('active')
				var rows = this.parentElement.parentElement.querySelector( '.community-service__rows' );
				var wrapper = rows.firstElementChild;
				var row_height = wrapper.offsetHeight + 32;     // Include bottom margin in wrapper height so it doesn't cut off bottom of last row (currently 2rem)

				if (this.classList.contains('active')) {
					rows.style.height = row_height + 'px';
				} else {
					rows.style.height = 0 + 'px';
				}
				this.parentElement.parentElement.parentElement.classList.toggle( 'active' );				
			});
		}
	}

	/**
	 * Form completion event for custom event trigger/goal completion
	 * 
	 * The point of this method is to eliminate false conversions in Analytics
	 * due to users refreshing the /thank-you/ page. This will now set a cookie after a form 
	 * submit event and get the form's id to pass into analytics. The analytics event for a goal
	 * conversion is then generated if there a form completion cookie set, and the url is that
	 * of a thank-you page. Each form will have a unique conversion event in Analytics based on
	 * the formID that gets passed as the event label.
	 * 
	 * There is the assumption that all forms on the site are a Gravity Form, and that
	 * they re-direct to a /thank-you/ page of some kind on completion.
	 */
	var form = document.querySelector('form');
	var popupForm = document.querySelector('.popup-form');

	if (popupForm) {
		popupForm.addEventListener('submit', function () {
			setCookie( 'form-completion', 'form-completion-value', 1 );
			setCookie( 'form-id', popupForm.getAttribute( 'id' ), 1 );
			console.log(popupForm.getAttribute( 'id' ));
		});
	} else if (form) {
		form.addEventListener('submit', function () {
			setCookie( 'form-completion', 'form-completion-value', 1 );
			setCookie( 'form-id', form.getAttribute( 'id' ), 1 );
		});
	}

	var formCompleted = readCookie( 'form-completion' );
	var formId = readCookie( 'form-id' );
	var thank = window.location.href.indexOf( 'thank' ) >= 0; // Not exactly thank-you because the page titles/urls vary, but all contain 'thank'
	var welcome = window.location.href.indexOf( 'welcome' ) >= 0;

	if ( formCompleted == 'form-completion-value' && (thank || welcome) ) {
		console.log(readCookie( 'form-completion' ));
		console.log(readCookie( 'form-id' ));
		
		// Create analytics event
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: "formSubmission",
			formID: formId
		});

		// Remove cookies so event cannot be fired again on /thank-you page refresh
		eraseCookie( 'form-completion');
		eraseCookie( 'form-id');
	}

	// 
	var imageAccents = document.querySelectorAll('.image-accent');

	window.addEventListener('scroll', function(event) {
		// add event on scroll
		imageAccents.forEach(element => {
			//for each .thisisatest
			if (isInViewport(element)) {
			//if in Viewport
			element.classList.add("in-view");
			}
		});
	}, false);

	/**
	 * Captures Google Analytics Client ID and inputs into hidden form field
	 */
	var g_id = document.querySelector('.g-id input' );

	function fillClientId() {
		// Capture Client ID
		var clientId = document.cookie.match(/_ga=(.+?);/)[1].split('.').slice(-2).join(".");
		// Populate hidden form field with Client ID
		g_id.value = clientId;
		console.log('fill id');
	}
	console.log('load');
	// On pages with client ID form field and analytics is loaded, populate
	if ( g_id && Object.keys( window.google_tag_manager || [] ).filter( e => { return e.substring(0,2) == 'G-' } ).length > 0 ) {
		console.log('in conditional');
		// Give GTM time to load
		setTimeout(function() {
			fillClientId();
		}, 5000);
	}
    
    // Change state for all Tri-State Mailing Equipment entries to NY
    var distributors = document.querySelectorAll('.distributor');
    distributors.forEach(function(distributor) {
        var title = distributor.querySelector('h3').innerText.toLowerCase();
        if (title === 'tri-state mailing equipment') {
            distributor.querySelector('.location').innerHTML = `
            <p class="location">
                <span>MT. VERNON</span>
                , 
                <span>NY</span>													 <span>10550</span>
            </p>
            `;
        }
    });
    
    var myStickyWrap = document.getElementById('mysticky-wrap');
    var myStickyNav = document.getElementById('mysticky-nav');
    var inkFormRefNav = document.querySelector('.ink-formulation-reference__nav');
    var activationHeight = pageData.activationHeight;
    if (inkFormRefNav) {
        var divWidth = inkFormRefNav.getBoundingClientRect().width;
    }
    
    window.addEventListener('scroll', function () {
        var scrollY = window.scrollY;
        
        if (activationHeight) {
            if (scrollY >= activationHeight) {
                myStickyNav.classList.add('wrapfixed');
                inkFormRefNav.classList.add('myfixed');
                inkFormRefNav.style.width = divWidth + "px";
                myStickyWrap.style.height = 0;
            } else {
                myStickyNav.classList.remove('wrapfixed');
                inkFormRefNav.classList.remove('myfixed');
            }
        } else if (scrollY >= 1100) {
            myStickyWrap.style.height = 0;
        }
    });
});

/**
 * Check if user is coming from Inktank, and if so, store their referring page
 * in local storage in case they convert for analytics.
 */
var referrer = document.referrer;
var referrer_field = document.querySelector('.referrer-field input');

if ( referrer.indexOf( 'inktank' ) > 0 && localStorage.getItem('referrer') == null ) {
	localStorage.setItem('referrer', referrer);
}

/**
 * Detects if element is in viewport
 */
 function isInViewport(elem) {
	var distance = elem.getBoundingClientRect();
	return (
		distance.top >= 0 &&
		distance.left >= 0 &&
		distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		distance.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
};


/*
* Google Tag Manager Attributes
*/
// All links except those in the portfolio grid, they have their own script in the template.
var links = document.querySelectorAll('a:not(.grid-link)');
var header = document.getElementById('site-header');
var body = document.getElementById('content');
var footer = document.getElementById('site-footer');

for (let link of links) {
	var tagClassName = link.textContent.replace(/[^a-zA-Z ]/g, "").replace(/ +(?= )/g,'').replace(/^ /, '').substring(0, 26);
	
	if (tagClassName == undefined || tagClassName == '' || tagClassName == ' ') {
		tagClassName = link.getAttribute("href");
	}

	link.setAttribute('data-link-label', tagClassName );

	try {
		var href =  link.getAttribute( 'href' );

		if ( href.match( /contact-us/ ) ) {
			link.setAttribute('data-link-cat', 'Contact Link' );
		} else if (	href.match( /inks/ ) ) {
			link.setAttribute('data-link-cat', 'Ink Link' );
		} else {
			link.setAttribute('data-link-cat', 'Other Link' );
		}

		//Link Location
		if ( header.contains(link) ) {
			link.setAttribute('data-link-action', 'Header Link' );
		} else if ( body.contains(link) ) {
			link.setAttribute('data-link-action', 'Body Link' );
		} else if ( footer.contains(link) ) {
			link.setAttribute('data-link-action', 'Footer Link' );
		} else {
			link.setAttribute('data-link-action', 'Other Link' );
		}

	} catch(e) {
		console.log (e );
	}
}

var popUp			= document.getElementById('cookie-popup');
var popUpMain		= document.getElementById('popup-main');
var moreInfo		= document.getElementById('more-info');
var acceptButton	= document.getElementById('accept');
var learnMoreButton	= document.getElementById('learn-more');

if ( popUp ) {
	// Hide popup and background filter and set cookie
	function accept() {
		popUp.style.display = "none";
		document.body.classList.add('cookies');
		setCookie( "accepts-cookie", "accepts-cookie-set", 365 );
	}

	// Hide main copy and reveal more info copy
	function learnMore() {
		popUpMain.style.display = "none";
		moreInfo.style.display = "block";
		moreInfo.setAttribute("aria-live", "assertive");
		acceptButton.focus();
	}

	acceptButton.addEventListener('click', function() {
		accept();
	});

	learnMoreButton.addEventListener('click', function() {
		learnMore();
	});


	var cookie = readCookie( 'accepts-cookie' );
	// If user already has accepted cookies, don't show popup
	if ( cookie == 'accepts-cookie-set' ) {
		popUp.style.display = "none";
		document.body.classList.add('cookies');
	} else {
		// Force screen reader to read popup
		popUpMain.setAttribute("aria-live", "assertive");
		learnMoreButton.focus();
	}
}

// region switcher menu changes. 2022-09-03
document.addEventListener( 'input', function (event) {
	if ( event.target.classList.contains('region-switcher') ) {
        var pathname = new URL( window.location.href ).pathname;
		var region = readCookie( 'kao_active_region' );
		var new_region = event.target.value;  // the dropdown value
		var cookiedays = 7;
		if ( dbs.debug ) console.log('new region: ' + new_region + '   region: ' + region);
		var host = dbs.domain;
		if ( dbs.debug ) console.log( 'hostnew:' + host);
//		if (new_region == region ) return;  // do nothing
		// erase cookie first since its possible to have different cookies per domain. 2022-05-03
		setCookie( 'kao_active_region', null, -99 );  // not working :(, prolly don't need it.
		setCookie( 'kao_active_region', new_region, cookiedays );
		if ( dbs.debug ) console.log('set new region: ' + new_region );
        if ( pathname !== '/' ) host += pathname;
		if ( new_region === 'america' ) {
			window.location.href = '//' + host;
			if ( dbs.debug ) console.log('host america: ' + host );
		} else {
			window.location.href = '//' + new_region + '.' + host;
			if ( dbs.debug ) console.log('host not america: ' + new_region + '.' + host );
		}
	}
});

window.onJQueryLoad(function(){
    jQuery( '.collapsible-row' ).find( '.collapsible-row-content' ).slideUp();
    jQuery( '.collapsible-row' ).on( 'click', function() {
        jQuery( this ).toggleClass( 'expanded' );
        jQuery( this ).find( '.collapsible-row-content' ).slideToggle(200);
    });
});
